import { t } from 'i18next'

import { Filters } from '~/components/Filters'
import Loading from '~/components/Loading'
import Panel from '~/components/Panel'
import AdsTable from '~/modules/retailMedia/components/_tables/AdsTable'
import CampaignCategoryTable from '~/modules/retailMedia/components/_tables/CampaignCategoriesTable'
import CampaignKeyWordTable from '~/modules/retailMedia/components/_tables/CampaignKeyWordTable'
import CampaignPlacementsTable from '~/modules/retailMedia/components/_tables/CampaignPlacementsTable'
import MediaRejectedTable from '~/modules/retailMedia/components/_tables/MediaRejectedTable'
import ProductsTable from '~/modules/retailMedia/components/_tables/ProductsTable'
import AdditionalAssetsBannerVideo from '~/modules/retailMedia/components/AdditionalAssetsBannerVideo'
import AudiencePanel from '~/modules/retailMedia/components/AudiencePanel'
import Budget from '~/modules/retailMedia/components/Budget'
import DestinationUrls from '~/modules/retailMedia/components/Campaign/DestinationUrls'
import { CampaignInsertionOrderPanel } from '~/modules/retailMedia/components/CampaignInsertionOrderPanel'
import CampaignSubpublishers from '~/modules/retailMedia/components/CampaignSubpublishers'
import { DailyCost } from '~/modules/retailMedia/components/DailyCost'
import DailyHistoryTable from '~/modules/retailMedia/components/DailyHistoryTable'
import { InfoView } from '~/modules/retailMedia/components/InfoView'
import { ReviewBar } from '~/modules/retailMedia/components/ReviewBar'
import ReviewCampaignProducts from '~/modules/retailMedia/components/ReviewCampaignProducts'
import ReviewCampaignTargeting from '~/modules/retailMedia/components/ReviewCampaignTargeting'
import { StatusBar } from '~/modules/retailMedia/components/StatusBar'
import StatusHistory from '~/modules/retailMedia/components/StatusHistory'
import { retailMediaAdsFiltersInsideCampaignBanner } from '~/modules/retailMedia/store/common/filters'

import MetricsCampaignView from '../Metrics'

const ViewBannerCampaign: React.FC<ViewCampaignProps> = ({ data, loading }) => {
  const hasKeywords =
    data?.targetingType === 'keyword' || !!data.keywords?.length
  const hasCategories =
    data?.targetingType === 'category' || !!data.banners?.categories?.length
  const hasPlacements = !!data.settings?.has_placements
  const hasAudience = !!data.audienceId
  const isSubpublisherReview = !!data.isSubpublisherReview
  const isPendingSubpublisherReview =
    isSubpublisherReview && data.status === 'pending_review'

  const isReviewOrRejected = ['pending_review', 'rejected'].includes(
    data.status
  )
  const hideExtras = isReviewOrRejected || isSubpublisherReview
  // `cpm == null`: 0 é valor válido de CPM e não deve ser tratado como ausente.
  const showDailyCost = data.settings?.cpm == null

  return (
    <>
      {showDailyCost && !isSubpublisherReview && <DailyCost data={data} />}

      <ReviewBar
        status={data?.status}
        adType={data?.adType}
        message={
          data?.status_history?.length > 0 ? data?.status_history[0]?.note : ''
        }
      />

      {isSubpublisherReview && !isPendingSubpublisherReview && (
        <DestinationUrls data={data} loading={loading} />
      )}

      <hr />

      {!hideExtras && (
        <>
          <Filters {...retailMediaAdsFiltersInsideCampaignBanner} columns={4} />
          <MetricsCampaignView />
        </>
      )}

      <Loading status={loading}>{t('rm:campaigns.loading')}</Loading>

      {!isSubpublisherReview && (
        <AdsTable campaignAdType={data.adType} campaignStatus={data.status} />
      )}

      {!hideExtras && (
        <>
          <hr />

          <DailyHistoryTable
            campaignType={data.adType}
            campaignStartDate={data.raw.start_at}
          />
        </>
      )}

      {isSubpublisherReview ? (
        <>
          <ReviewCampaignTargeting data={data} />
          <ReviewCampaignProducts products={data.products} />
        </>
      ) : (
        <>
          {/* {hasProducts && ( */}
          <>
            <hr />
            <Panel
              template="shoreline"
              title={t('rm:relatedProducts')}
              isCollapsible
              noPaddingBody
            >
              <ProductsTable
                campaignId={data.id}
                publisherId={data.publisher.id}
              />
            </Panel>
          </>
          {/* )} */}

          {hasKeywords && (
            <>
              <hr />
              <CampaignKeyWordTable campaignId={data.id} />
            </>
          )}

          {hasCategories && (
            <>
              <hr />
              <CampaignCategoryTable
                campaignId={data.id}
                publisherId={data.publisher.id}
              />
            </>
          )}

          {hasAudience && (
            <>
              <hr />
              <AudiencePanel audienceId={data.audienceId} />
            </>
          )}

          {hasPlacements && (
            <>
              <hr />
              <CampaignPlacementsTable campaignId={data.id} />
            </>
          )}

          <hr />

          <Budget data={data} loading={loading} />

          <CampaignInsertionOrderPanel
            campaignId={data.id}
            insertionOrders={data.insertionOrders}
          />

          <CampaignSubpublishers
            publisherId={data.publisher.id}
            campaignData={data}
          />

          <InfoView data={data} />

          <AdditionalAssetsBannerVideo data={data} />

          {!hideExtras && (
            <StatusBar
              status={data?.status}
              message={
                data?.status_history?.length > 0
                  ? data?.status_history[0]?.note
                  : ''
              }
            />
          )}

          <hr />

          <DestinationUrls data={data} loading={loading} />

          <MediaRejectedTable />

          <StatusHistory data={data?.status_history} />
        </>
      )}
    </>
  )
}

export default ViewBannerCampaign
